exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filtro[data-v-28a9abb2] {border: 0; overflow: hidden;position: relative; box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;}\n.filtro svg[data-v-28a9abb2] {display: block;}\n", ""]);

// exports
